export const URLS = {
    userPhoneValidate: '/api/phones/validate'
};
